import lazyLoadImages from "../js/components/lazyLoad";
import { handleVariations } from "../js/components/variations";

// const { default: lazyLoadImages } = require("./components/lazyLoad")
const { toggleScroll } = require("./components/_helpers");

document.body.addEventListener("force_lazyload", (e) => {
  //   new lazyLoadImages().update();
  // lazy.update()
});

document.addEventListener("DOMContentLoaded", () => {
  toggleFilters();
});

// if (innerWidth <= 1199) {
//     document.querySelector('.open-filters').addEventListener('click', e => {
//         document.querySelector('.ajax-filtering-wrapper').classList.toggle('active')
//         document.querySelector('.bg-close-filters').classList.toggle('active')
//         document.querySelector('.close-filters').classList.toggle('active')

//         toggleScroll()

//     })
//     document.querySelector('.close-filters').addEventListener('click', e => {
//         document.querySelector('.open-filters').click()
//     })
//     document.querySelector('.bg-close-filters').addEventListener('click', e => {
//         document.querySelector('.open-filters').click()
//     })
// }

const toggleFilters = async () => {
  const buttons = document.querySelectorAll(".toggle-filter");
  const filters = document.querySelector("nav.woocommerce-products-header");

  buttons?.forEach((button) => {
    button.addEventListener("click", () => {
      toggleScroll();
      filters.classList.toggle("md:translate-x-full");
      document.querySelector("#header")?.classList.add("scrolled");
      document.querySelector(".toggle-filter.filter-close")?.classList.toggle("hidden");
    });
  });
};

jQuery(document).on("ajaxComplete", (e) => {
  new lazyLoadImages().update();
});

window.addEventListener("DOMContentLoaded", handleVariations);
jQuery(document).on("ajaxComplete", handleVariations);

document.body.addEventListener("force_lazyload", handleVariations);
